__turbopack_context__.v({
  "close-button": "WhatsNewDashboard-module-scss-module__-WEmmW__close-button",
  "content": "WhatsNewDashboard-module-scss-module__-WEmmW__content",
  "controls": "WhatsNewDashboard-module-scss-module__-WEmmW__controls",
  "controls-wrapper": "WhatsNewDashboard-module-scss-module__-WEmmW__controls-wrapper",
  "footer-controls": "WhatsNewDashboard-module-scss-module__-WEmmW__footer-controls",
  "is-selected": "WhatsNewDashboard-module-scss-module__-WEmmW__is-selected",
  "start": "WhatsNewDashboard-module-scss-module__-WEmmW__start",
  "switch": "WhatsNewDashboard-module-scss-module__-WEmmW__switch",
  "switch-tab": "WhatsNewDashboard-module-scss-module__-WEmmW__switch-tab",
  "switch-wrapper": "WhatsNewDashboard-module-scss-module__-WEmmW__switch-wrapper",
  "wrapper": "WhatsNewDashboard-module-scss-module__-WEmmW__wrapper",
});
